// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1tpiO","requiredAsterisk":"Info_requiredAsterisk__1qROl"};